// extracted by mini-css-extract-plugin
export default {"table":"MovableTable_table__d242I","tableWrapper":"MovableTable_tableWrapper__qAOkE"};